import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applyBrandingTheme } from './lib/brandingTheme'

// Apply cached theme ASAP to avoid a brief flash of default colors on load.
try {
  const raw = localStorage.getItem('gymadmin_branding_last')
  if (raw) {
    applyBrandingTheme(JSON.parse(raw))
  }
} catch (_e) {
  // Best-effort only.
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
